(function () {
	'use strict';

	// Store stats
	var lastST = 0;
	var lastSTns = 0;
	var sensitivity = 200; // How far do you have to scroll for it to be considered "far"

	// Update scroll stats
	var scrollStats = function () {
		var st = window.scrollY || window.pageYOffset;
		var remove = [];
		var add = [];

		// If user has scrolled at all
		if (Math.abs(lastSTns - st) > 0) {
			// User is scrolling down
			if (st > lastSTns) {
				remove.push('scrolling-up');
				remove.push('scrolling-up-far');
				add.push('scrolling-down');
				add.push('has-scrolled-down');
			}
			// User is scrolling up
			else {
				remove.push('scrolling-down');
				remove.push('scrolling-down-far');
				add.push('scrolling-up');
				add.push('has-scrolled-up');
			}

			lastSTns = st;
		}

		// If user has scrolled past sensitivity (he has scrolled "far")
		if (Math.abs(lastST - st) > sensitivity) {
			// User is scrolling down
			if (st > lastST) {
				remove.push('scrolling-up-far');
				add.push('scrolling-down-far');
				add.push('has-scrolled-down-far');
			}
			// User is scrolling up
			else {
				remove.push('scrolling-down-far');
				add.push('scrolling-up-far');
				add.push('has-scrolled-up-far');
			}

			lastST = st;
		}

		// Has user scrolled away from top
		if (st > 0) {
			remove.push('at-top');
			add.push('has-scrolled');
		}
		// No - user is at the top
		else {
			remove.push('has-scrolled');
			remove.push('scrolling-down');
			remove.push('has-scrolled-down');
			remove.push('scrolling-down-far');
			remove.push('has-scrolled-down-far');
			remove.push('scrolling-up');
			remove.push('has-scrolled-up');
			remove.push('scrolling-up-far');
			remove.push('has-scrolled-up-far');
			add.push('at-top');
		}

		// Add and remove classes to <html> element
		window.requestAnimationFrame(function () {
			remove.forEach(function (cssClass) {
				document.documentElement.classList.remove(cssClass);
			});

			add.forEach(function (cssClass) {
				document.documentElement.classList.add(cssClass);
			});
		});
	};

	// Call now
	scrollStats();

	// Check if browser supports passive event listeners
	var supportsPassive = false;

	try {
		var opts = Object.defineProperty({}, 'passive', {
			get: function() {
				supportsPassive = true;
			}
		});

		window.addEventListener('testPassive', null, opts);
		window.removeEventListener('testPassive', null, opts);
	} catch (e) {}

	// And on scroll
	window.addEventListener('scroll', scrollStats, supportsPassive ? {passive: true} : false);
})();
